'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /walletexpnodeweb-ci-6534/workspace/consumerweb-release/~/react/react.js
// module id = 56
// module chunks = 0